/*
 * Page Name
 */

(function ($) {

    var interview_block04_slide = new Swiper(".interview_block04_slide", {
        slidesPerView: 3,
        spaceBetween: 20,
        // loop: true,
        // autoplay: {
        //     delay: 2500,
        //     disableOnInteraction: false,
        // },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                loop: true,
                centeredSlides: true
            },
            800: {
                slidesPerView: 3,
                loop: false,
                centeredSlides: false
            }
        },
    });

    interview_block04_slide.on('slideChangeTransitionStart', function () {
        jQuery('.interview_block04_slide .swiper-wrapper').css({ transition: 'transform 1000ms ease 0s' })
    });

    var aamySwiper = new Swiper(".aamySwiper", {
        slidesPerView: 3,
        spaceBetween: 30,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    var topInterview_box_item = $('.topInterview_box_item');
    if (topInterview_box_item.length > 0) {
        topInterview_box_item.on('inview', function (event, isInView) {
            if (isInView) {
                setTimeout(function () {
                    topInterview_box_item.each(function () {
                        var imgH = $(this).find('.img').height();
                        $(this).css('min-height', imgH);
                    });
                }, 100)
            }
        });
    }

})(jQuery);
